<template>
  <nav class="pagination" role="navigation" aria-label="pagination"  v-show="data.totalPages>1" :class="pagingClass">
    <ul class="pagination-list">
      <li>
        <a
          class="pagination-link pagination-first"
          @click="onClickFirstPage"
          :disabled="isInFirstPage"
          aria-label="Go to first page"
        >
          Первая
        </a>
      </li>
      <li>
        <a
          class="pagination-previous"
          @click="onClickPreviousPage"
          :disabled="isInFirstPage"
          aria-label="Go to previous page"
        >
          Предыдущая
        </a>
      </li>
      <li v-for="page in pages">
        <a
          class="pagination-link"
          @click="onClickPage(page.name)"
          :disabled="page.isDisabled"
          :class="{ activepage: isPageActive(page.name) }"
          :aria-label="`Go to page number ${page.name}`"
        >
          {{ page.name }}
        </a>
      </li>
      <li>
        <a
          class="pagination-next"
          @click="onClickNextPage"
          :disabled="isInLastPage"
          aria-label="Go to next page"
        >
          Следующая
        </a>
      </li>
      <li>
        <a
          class="pagination-link pagination-last"
          @click="onClickLastPage"
          :disabled="isInLastPage"
          aria-label="Go to last page"
        >
          Последняя
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
    export default {
        name: 'Paging',
        props: ['refresh', 'perPage', 'data', 'pagingClass'],
        data () {
            return {
                maxVisibleButtons: 10
            }
        },
        computed: {
            totalPages() {
                return this._props.data.totalPages
            },
            startPage() {
                if (this.currentPage() === 1) {
                    return 1
                }

                if (this.currentPage() === this.totalPages) {
                    return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
                }

                return this.currentPage() - 1
            },
            endPage() {
                return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
            },
            pages() {
                const range = []
                for (let i = this.startPage; i <= this.endPage; i += 1) {
                    range.push({
                        name: i,
                        isDisabled: i === this.currentPage()
                    })
                }
                return range
            },
            isInFirstPage() {
                return this._props.data.first
            },
            isInLastPage() {
                return this._props.data.last
            }
        },
        methods: {
            onClickFirstPage() {
                this.onPageChange(1)
            },
            onClickPreviousPage() {
                this.onPageChange(this.currentPage() - 1)
            },
            onClickPage(page) {
                this.onPageChange(page)
            },
            onClickNextPage() {
                this.onPageChange(this.currentPage() + 1)
            },
            onClickLastPage() {
                this.onPageChange(this.totalPages)
            },
            isPageActive(page) {
                return this.currentPage() === page
            },
            onPageChange(page) {
                this._props.refresh(page)
            },
            currentPage() {
                return this._props.data.number + 1
            }
        }
    }
</script>

<style scoped>
 .pagination.top {
   margin-bottom: 10px;
 }
 .pagination.bottom {
   margin-top: 10px;
 }

  .pagination-next, .pagination-previous {
    margin-left: 0;
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// Paging.vue?2baa8286